export default __webpack_public_path__ + "static/media/Logo.fe8bda9b.svg";